<template>
  <section>
      <PortalPainelDestaque />
      </section>
</template>

<script>
import { mapGetters } from 'vuex';
import intro from '@/portal/intros/PortalIntro.js';
import PortalPainelDestaque from '../components/destaque/PortalPainelDestaque';
import { Getters } from '../store/types';

export default {

    name: 'Servicos',

    components: {
        PortalPainelDestaque,
    },

    computed: {
        ...mapGetters({
            carregado: Getters.NOTIFICACOES.STATUS_CARREGADO
        })
    },

    mounted(){
       if(this.carregado){
           intro.carregar('TAREFAS_AVISOS').iniciar();
       }
    },

    watch:{
        carregado(status){
            if(status && this.$router.currentRoute.path === '/painel'){
                intro.carregar('TAREFAS_AVISOS').iniciar();
            }
        }
    }

}
</script>

<style>

</style>